//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BottomNavigation',
  props: {},
  data() {
    return {
      navigationList: [
        {
          name: '题目',
          icon: 'icon-radius-add',
          class: 'navigation-icon',
          handler: this.add,
        },
        {
          name: '预览',
          icon: 'icon-view',
          class: 'navigation-icon',
          handler: this.view,
        },
        {
          name: '设置',
          icon: 'icon-setting',
          class: 'navigation-icon',
          handler: this.setting,
        },
        {
          name: '发布',
          icon: 'icon-release1',
          class: 'navigation-icon',
          handler: this.release,
        },
      ],
    }
  },
  watch: {},
  computed: {},
  methods: {
    add() {
      this.$emit('action','add')
    },
    release() {
      this.$emit('action','release')
    },
    setting() {
      this.$emit('action','setting')
    },
    view() {
      this.$emit('action','view')
    },
  },
}
